import { useEffect } from 'react';
import { useChatWidgetContext } from './ChatWidgetContext';
import { clearTransferState, setTransferState } from './chatTransferStore';
import { detachRelayListener } from './streamRelay';

export default function TransferOnLeave() {
  const {
    currentConversationId,
    messages,
    streamingText,
    isStreaming,
    selectedContext,
  } = useChatWidgetContext();

  if (currentConversationId) {
    setTransferState({
      conversationId: currentConversationId,
      messages,
      streamingText,
      isStreaming,
      selectedContext,
    });
  } else {
    clearTransferState();
  }

  useEffect(() => {
    return () => {
      detachRelayListener();
    };
  }, []);

  return null;
}
